import { useMemo } from "react";
import { Grid, Tooltip, Typography } from "@mui/material";
// Device Icons
import TabletMacIcon from "@mui/icons-material/TabletMac";
// Battery Icons
import Bat0 from "@mui/icons-material/Battery0Bar";
import Bat1 from "@mui/icons-material/Battery1Bar";
import Bat2 from "@mui/icons-material/Battery2Bar";
import Bat3 from "@mui/icons-material/Battery3Bar";
import Bat4 from "@mui/icons-material/Battery4Bar";
import Bat5 from "@mui/icons-material/Battery5Bar";
import Bat6 from "@mui/icons-material/Battery6Bar";
import BatFull from "@mui/icons-material/BatteryFull";
import BatUnknown from "@mui/icons-material/BatteryUnknown";
import { IEFBSummaryDevice, IEFBSummaryState } from "@vmosolutions/oc-interfaces";

interface ICrewDevice {
  device: IEFBSummaryDevice;
  state: IEFBSummaryState;
}

export const CrewDeviceInfo = (props: ICrewDevice): JSX.Element => {
  const { device, state } = props;
  const versionInfo = `${device?.systemName ?? ""} version ${state?.systemVersion ?? "unknown"}`;

  return (
    <Grid container>
      <Tooltip title={versionInfo} placement="top">
        <TabletMacIcon sx={{ height: "15px", marginTop: "4px", color: "white" }} />
      </Tooltip>
      <Typography sx={{ fontSize: "12px", marginTop: "4px" }}>{device?.model ?? ""}</Typography>
    </Grid>
  );
};

export const CrewDeviceBattery = (props: ICrewDevice): JSX.Element => {
  const { device, state } = props;

  const BatteryIcon: JSX.Element = useMemo(() => {
    switch (state?.batteryLevel) {
      case 1:
        return <BatFull sx={{ height: 16, color: "white" }} />;
      case 0.9:
      case 0.8:
        return <Bat6 sx={{ height: 16, color: "white" }} />;
      case 0.7:
        return <Bat5 sx={{ height: 16, color: "white" }} />;
      case 0.6:
        return <Bat4 sx={{ height: 16, color: "white" }} />;
      case 0.5:
        return <Bat3 sx={{ height: 16, color: "white" }} />;
      case 0.4:
      case 0.3:
        return <Bat2 sx={{ height: 16, color: "white" }} />;
      case 0.2:
      case 0.1:
        return <Bat1 sx={{ height: 16, color: "white" }} />;
      case 0:
        return <Bat0 sx={{ height: 16, color: "white" }} />;
      default:
        return <BatUnknown sx={{ height: 16, color: "white" }} />;
    }
  }, [state?.batteryLevel]);

  const batteryPercentage =
    state?.batteryLevel > 0
      ? Math.round(state?.batteryLevel * 100).toString() + "%"
      : state?.batteryLevel === 0
        ? "0%"
        : "unknown";

  return (
    <Grid container>
      {BatteryIcon}
      <Typography sx={{ fontSize: "12px" }}>{batteryPercentage}</Typography>
    </Grid>
  );
};
